import React, { useEffect, useState } from 'react';
import { IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { ArrowDownward, ArrowUpward } from "@mui/icons-material";
import { IBidOfferData } from '../../../../shared/types/analytics/trading-analytics/IBidOfferData';

const headCells: HeadCell[] = [
    {
        id: "siteID",
        label: "Site ID",
        dataType: "String"
    },
    {
        id: "boa",
        label: "BOA",
        dataType: "Power"
    },
    {
        id: "fpn",
        label: "FPN",
        dataType: "Power"
    },
    {
        id: "price",
        label: "Price",
        dataType: "Price"
    },
]

const BalancingSummaryBOATable: React.FC<IBalancingSummaryBOATable> = ({ items, defaultSortKey = "price", defaultOrderDescending = false }) => {
    const [orderDescending, setOrderDescending] = useState<boolean>(defaultOrderDescending);
    const [orderCategory, setOrderCategory] = useState<keyof IBidOfferData>(defaultSortKey);

    const sortItems = (inputArray: IBidOfferData[], category: keyof IBidOfferData, descending: boolean) => {
        const outputArray = [...inputArray]
        outputArray.sort((a, b) => {
            const aValue = a[category]
            const bValue = b[category]
            if (aValue === null) { return 1 }
            else if (bValue === null) { return -1 }
            else if (aValue < bValue) { return -1 }
            return 1
        })
        if (descending) {
            outputArray.reverse()
        }
        return outputArray
    }

    useEffect(() => {
        setInternalItems(sortItems(items, orderCategory, orderDescending))
    }, [items])

    if (items === undefined) {
        items = []
    }

    const [internalItems, setInternalItems] = React.useState<IBidOfferData[]>(sortItems(items, orderCategory, orderDescending))

    const handleSort = (categoryID: keyof IBidOfferData) => {
        let descending = false
        if (orderCategory === categoryID && !orderDescending) {
            descending = true
        }
        setOrderDescending(descending)
        setOrderCategory(categoryID)
        setInternalItems(sortItems(internalItems, categoryID, descending))
    }

    return (
        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
            <TableContainer sx={{ maxHeight: 200 }}>
                <Table stickyHeader size="small" aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            {headCells.map((headCell) => (
                                <TableCell
                                    align="center"
                                    key={headCell.id}
                                >
                                    <IconButton
                                        size="small"
                                        sx={{ "transition": "all .2s", "color": "inherit", "&:hover": { "backgroundColor": "rgba(160, 160, 160, 0.5)" } }}
                                        onClick={() => handleSort(headCell.id)}
                                    >
                                        <Typography variant="subtitle1" fontSize="small">{headCell.label}</Typography>
                                        {headCell.id === orderCategory ? (orderDescending ? < ArrowDownward fontSize="small" /> : <ArrowUpward fontSize="small" />) : <></>}
                                    </IconButton>
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {internalItems
                            .map((item) => {
                                const rowKey = "Balancing-BOA-table-key-" + item.siteID + "-" + item.price
                                return (
                                    <TableRow key={rowKey}>
                                        {
                                            headCells.map((headCell) => {

                                                const cellValue = item[headCell.id].toString()
                                                let cellContents = <>{cellValue.toString()}</>
                                                if (headCell.dataType === "Price") {
                                                    cellContents = <>&pound;{parseFloat(cellValue).toFixed(2).toString()}</>
                                                }
                                                else if (headCell.dataType === "Power") {
                                                    cellContents = <>{parseFloat(cellValue).toFixed(0).toString()}MW</>
                                                }

                                                return (
                                                    <TableCell
                                                        key={rowKey + "-" + headCell.id}
                                                        align="center"
                                                    >
                                                        {cellContents}
                                                    </TableCell>
                                                )
                                            })
                                        }
                                    </TableRow>
                                )
                            })
                        }
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    );

}
interface HeadCell {
    id: keyof IBidOfferData,
    label: string,
    dataType: "String"|"Price"|"Power"
}
export interface IBalancingSummaryBOATable {
    items: IBidOfferData[],
    defaultSortKey?: keyof IBidOfferData
    defaultOrderDescending?: boolean
}

export default BalancingSummaryBOATable;